module.exports = __webpack_public_path__ + "static/media/electrical.3cfa649f.svg";